// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  margin: 1rem;
  font-family: Arial, Helvetica, sans-serif;
}

.box {
  box-shadow: 0px 1px 22px -12px #607d8b;
  background-color: #fff;
  padding: 25px 35px 25px 30px;
}

@media screen and (max-width: 760px) {
  .box {
    padding: 25px 0;
  }
}

.sparkboxes .box {
  padding: 3px 0 0 0;
  position: relative;
  padding-top: 15px;
}

/* overrides */
.sparkboxes #apexcharts-subtitle-text {
  fill: #8799a2 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,wBAAwB;AAC1B","sourcesContent":[".App {\n  margin: 1rem;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.box {\n  box-shadow: 0px 1px 22px -12px #607d8b;\n  background-color: #fff;\n  padding: 25px 35px 25px 30px;\n}\n\n@media screen and (max-width: 760px) {\n  .box {\n    padding: 25px 0;\n  }\n}\n\n.sparkboxes .box {\n  padding: 3px 0 0 0;\n  position: relative;\n  padding-top: 15px;\n}\n\n/* overrides */\n.sparkboxes #apexcharts-subtitle-text {\n  fill: #8799a2 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
